import { computed } from "@vue/composition-api";
import annotations from "@/store/modules/annotations";

export default function useFindNeighbors() {
  const nodes = computed(() => annotations.getNodes);
  const nodeNeighbors = computed(() => annotations.neighbors);

  /**
   *
   * @param {number} index - index of node to find neighbors for
   */
  const findVHNeighbors = index => {
    const ret = [];

    let neighbors = nodeNeighbors.value(index);
    neighbors = neighbors.filter(i => i !== index);
    neighbors.forEach(i => {
      if (nodes.value[index].pos.cx === nodes.value[i].pos.cx) {
        findHorizontalNeighborsRecursive(i, ret);
      } else if (nodes.value[index].pos.cy === nodes.value[i].pos.cy) {
        findVerticalNeighborsRecursive(i, ret);
      }
    });

    return ret;
  };

  const findAllVHNeighbors = index => {
    const ret = [];

    findAllVHNeighborsRecursive(index, ret);

    return ret;
  };

  const findAllVHNeighborsRecursive = (index, ret) => {
    ret.push(index);

    let neighbors = nodeNeighbors.value(index);
    neighbors = neighbors.filter(i => ret.indexOf(i) === -1);
    neighbors.forEach(i => {
      if (nodes.value[index].pos.cy === nodes.value[i].pos.cy) {
        findAllVHNeighborsRecursive(i, ret);
      } else if (nodes.value[index].pos.cx === nodes.value[i].pos.cx) {
        findAllVHNeighborsRecursive(i, ret);
      }
    });
  };

  const findVerticalNeighbors = index => {
    const ret = [];
    findVerticalNeighborsRecursive(index, ret);
    return ret;
  };

  const findHorizontalNeighbors = index => {
    const ret = [];
    findHorizontalNeighborsRecursive(index, ret);
    return ret;
  };

  const findVerticalNeighborsRecursive = (index, ret) => {
    ret.push(index);

    let neighbors = nodeNeighbors.value(index);
    neighbors = neighbors.filter(i => ret.indexOf(i) === -1);
    neighbors.forEach(i => {
      if (nodes.value[index].pos.cy === nodes.value[i].pos.cy) {
        findVerticalNeighborsRecursive(i, ret);
      }
    });
  };

  const findHorizontalNeighborsRecursive = (index, ret) => {
    ret.push(index);

    let neighbors = nodeNeighbors.value(index);
    neighbors = neighbors.filter(i => ret.indexOf(i) === -1);
    neighbors.forEach(i => {
      if (nodes.value[index].pos.cx === nodes.value[i].pos.cx) {
        findHorizontalNeighborsRecursive(i, ret);
      }
    });
  };

  return {
    findVHNeighbors,
    findAllVHNeighbors,
    findVerticalNeighbors,
    findHorizontalNeighbors
  };
}
